import { render, staticRenderFns } from "./CommodityMarketingDiscussItemImages.vue?vue&type=template&id=31222e28&scoped=true&"
import script from "./CommodityMarketingDiscussItemImages.vue?vue&type=script&lang=js&"
export * from "./CommodityMarketingDiscussItemImages.vue?vue&type=script&lang=js&"
import style0 from "./CommodityMarketingDiscussItemImages.vue?vue&type=style&index=0&id=31222e28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31222e28",
  null
  
)

export default component.exports